import PageTitle from '../components/PageTitle';
import PageContainer from '../components/page-container/PageContainer';
import NewCalculationTemplateForm from '../features/calculation-template/NewCalculationTemplateForm';

function NewCalculationTemplatePage(): JSX.Element {
    return (
        <PageContainer>
            <div className="pb-4">
                <div className="pb-4 border-b">
                    <PageTitle title="New Calculation Template" />
                </div>
                <div className="mx-auto w-full max-w-[450px] mt-8">
                    <NewCalculationTemplateForm />
                </div>
            </div>
        </PageContainer>
    );
}

export default NewCalculationTemplatePage;
